import {useGetAssessmentStats} from '@/api/CoachAndDirector/useGetAssessmentStats';
import {roleType} from '@/constants/constants';
import {AssessmentStatsView} from '@/pages/Coach/CoachAssessmentStats/AssessmentStats.view';

interface AssessmentStatsProps {
  assessmentId: string;
}

export const DirectorAssessmentStats = ({assessmentId}: AssessmentStatsProps) => {
  const {data: assessmentStats} = useGetAssessmentStats(assessmentId, roleType.director);

  const totalPlayers = assessmentStats?.totalPlayers ?? 0;
  const assignedSessions = assessmentStats?.assignedSessions ?? 0;
  const completedSessions = assessmentStats?.completedSessions ?? 0;

  const yetToComplete = totalPlayers - completedSessions;

  return (
    <AssessmentStatsView
      totalPlayers={totalPlayers}
      assignedSessions={assignedSessions}
      completedSessions={completedSessions}
      yetToComplete={yetToComplete}
    />
  );
};
